export default {
  format: {
    date: 'd.MM.yyyy',
    time: 'HH:mm',
    dateTime: '$t(format:date) $t(format:time)',
  },

  translation: {
    common: {
      about: 'About 4ga Boards',
      aboutShort: 'About',
      account: 'Account',
      actions: 'Comments',
      activityBy: 'Activity by {{name}}',
      activityCreated: 'Created',
      activityFor: 'Activity for {{name}}',
      activityForComment: 'Activity for the comment by {{name}}',
      activityUpdated: 'Updated',
      addAttachment: 'Add attachment',
      addAttachmentButton: 'Add Attachment',
      addAttachmentExtra: '(Drop here, Ctrl+V or click to upload)',
      addBoard: 'Add Board',
      addCard: 'Add Card',
      addCardTooltip: 'Add card and open it: [Ctrl+Enter] or [Ctrl+Add Card Button]\nAdd multiple cards: [Shift+Enter] or [Shift+Add Card Button]',
      addComment: 'Add comment',
      addDescription: 'Add Description',
      addDueDate: 'Add Due Date',
      addLabel: 'Add Label',
      addList: 'Add List',
      addListTooltip: 'Add multiple lists: [Shift+Enter] or [Shift+Add List Button]',
      addManager_title: 'Add Manager',
      addMember_title: 'Add Member',
      addMember: 'Add Member',
      addMembers: 'Add Members',
      addProject: 'Add Project',
      addTask: 'Add Task',
      addUser: 'Add User',
      administrator: 'Administrator',
      allChangesWillBeAutomaticallySaved: 'All changes will be saved automatically once the connection is restored',
      allowedRegisterDomains: 'Allowed Registration Domains',
      allowedRegisterDomainsPlaceholder: 'example.com;example.org',
      anyDomain: 'Any Domain',
      anyMatch: 'Any Match [Alt+V]',
      areYouSureYouWantToDeleteThisAttachment: 'Are you sure you want to delete this attachment?',
      areYouSureYouWantToDeleteThisBoard: 'Are you sure you want to delete this board?',
      areYouSureYouWantToDeleteThisCard: 'Are you sure you want to delete this card?',
      areYouSureYouWantToDeleteThisComment: 'Are you sure you want to delete this comment?',
      areYouSureYouWantToDeleteThisLabel: 'Are you sure you want to delete this label?',
      areYouSureYouWantToDeleteThisList: 'Are you sure you want to delete this list?',
      areYouSureYouWantToDeleteThisProject: 'Are you sure you want to delete this project?',
      areYouSureYouWantToDeleteThisTask: 'Are you sure you want to delete this task?',
      areYouSureYouWantToDeleteThisUser: 'Are you sure you want to delete this user?',
      areYouSureYouWantToLeaveBoard: 'Are you sure you want to leave the board?',
      areYouSureYouWantToLeaveProject: 'Are you sure you want to leave the project?',
      areYouSureYouWantToRemoveThisManagerFromProject: 'Are you sure you want to remove this manager from the project?',
      areYouSureYouWantToRemoveThisMemberFromBoard: 'Are you sure you want to remove this member from the board?',
      attachment: 'Attachment',
      attachmentCount: 'Attachment Count',
      attachments: 'Attachments',
      authentication: 'Authentication',
      avatar: 'Avatar',
      avatarText: 'Profile picture',
      back: 'Back',
      background: 'Background',
      backToDashboard: 'Back to Dashboard',
      backToProject: 'Back to Project',
      beta: 'Beta',
      board_title: 'Board',
      board: 'board',
      boardNotFound_title: 'Board Not Found',
      boards_one: '{{count}} board',
      boards_other: '{{count}} boards',
      boards_title_one: '{{count}} Board',
      boards_title_other: '{{count}} Boards',
      boards_title: 'Boards',
      boards: 'boards',
      boardView: 'Board',
      canComment: 'Can comment',
      canEditContentOfBoard: 'Can edit the content of the board',
      cannotEditInstanceSettings: 'You are not authorized to edit instance settings!',
      cannotEditUsersSettings: 'You are not authorized to edit instance users!',
      canOnlyViewBoard: 'Can only view the board',
      card_title: 'Card',
      card: 'card',
      cardActions_title: 'Card Actions',
      cardDueDateSummary: 'The closest due date for card:',
      cardNotFound_title: 'Card Not Found',
      cards_one: '{{count}} card',
      cards_other: '{{count}} cards',
      cards_title_one: '{{count}} Card',
      cards_title_other: '{{count}} Cards',
      cards_title: 'Cards',
      cards: 'cards',
      checkActivity: 'Check Activity',
      checkUserAccountActivity: 'Check User Account Activity',
      clearFilter: 'Clear filter',
      close: 'Close',
      closeCard: 'Close Card',
      closeDropdown: 'Close dropdown',
      closestDueDate: 'Earliest Due',
      collapseList: 'Collapse List',
      color: 'Color',
      commentCount: 'Comment Count',
      compact: 'Compact',
      connectedToGithub: 'Connected to GitHub: {{repo}}',
      connections: 'Edit GitHub Connection',
      connectToGithub: 'Connect to GitHub',
      coverImage: 'Cover Image',
      created: 'Created',
      createdAt: 'Created At',
      createdBy: 'Created By',
      createLabel_title: 'Create Label',
      createTextFile_title: 'Create Text File',
      currentPassword: 'Current password',
      currentValue: 'Current Value',
      dangerZone_title: 'Danger Zone',
      dashboard: 'Dashboard',
      date: 'Date',
      default: 'Default',
      defaultView: 'Default View',
      deleteAll: 'Delete All',
      deleteAllRead: 'Delete All Read',
      deleteAttachment_title: 'Delete Attachment',
      deleteBoard_title: 'Delete Board',
      deleteCard_title: 'Delete Card',
      deleteComment_title: 'Delete Comment',
      deleteComment: 'Delete Comment',
      deleteLabel_title: 'Delete Label',
      deleteList_title: 'Delete List',
      deleteProject_title: 'Delete Project',
      deleteTask_title: 'Delete Task',
      deleteUser_title: 'Delete User',
      demoMode: 'Demo Mode',
      demoModeExplanation: 'Demo Mode - some features affecting other users are disabled! Every new user receives admin privileges.',
      demoModeGithubExtra: 'Your support speeds up development',
      demoModeGithubMain: 'Star 4ga Boards on GitHub!',
      description: 'Description',
      descriptionAllowedRegisterDomains: 'Semicolon separated list of allowed email domains for user registration. Leave empty to allow any domain.',
      descriptionCompactSidebar: 'This option makes the sidebar narrower.',
      descriptionDefaultView: 'Select the default view when opening the board.',
      descriptionHideCardModalActivity: 'Hide created and updated in card modal.',
      descriptionHideClosestDueDate: 'Hide closest due date in card modal.',
      descriptionLanguage: 'Select the language you want to use in 4ga Boards.',
      descriptionListViewStyle: 'Select the list view style.',
      descriptionLocalRegistration: 'Enable or disable local user registration. This registration method allows users to create an account with a username and password.',
      descriptionPreferredDetailsFont: 'Select the font you want to use in card description and comments.',
      descriptionProjectCreationAll: 'Enable or disable project creation for all users. If you disable project creation for all users, only admins will be able to create new projects.',
      descriptionSsoRegistration: 'Enable or disable SSO user registration. This registration method allows users to create an account using an external account e.g. Google Account.',
      descriptionSubscribeToInstance: 'Automatically subscribe to the instance notifications.',
      descriptionSubscribeToNewBoards: 'Automatically subscribe to boards I join.',
      descriptionSubscribeToNewProjects: 'Automatically subscribe to projects I join.',
      descriptionSubscribeToOwnCards: 'Automatically subscribe to cards I create.',
      descriptionSubscribeToUsers: 'Automatically subscribe to users notifications.',
      descriptionSyncSsoAdminOnAuth: 'Enable or disable synchronization of admin from the SSO provider during authentication. Enabling this option can automatically grant or revoke admin rights based on the SSO data.', // eslint-disable-line prettier/prettier
      descriptionSyncSsoDataOnAuth: 'Enable or disable synchronization of user data from the SSO provider during authentication.',
      descriptionTheme: 'Select the color theme of the application.',
      descriptionThemeShape: 'Select the shape of the application theme.',
      descriptionUserRegistration: 'Enable or disable all user registration methods. If you disable all registration methods, only administrators will be able to create new users.',
      descriptionUsersSettingsStyle: 'Select the style of the users settings.',
      detailsAttachments_one: 'This card has {{count}} attachment',
      detailsAttachments_other: 'This card has {{count}} attachments',
      detailsComments_one: 'This card has {{count}} comment',
      detailsComments_other: 'This card has {{count}} comments',
      detailsDescription: 'This card has a description',
      detailsNotifications_one: 'This card has {{count}} notification',
      detailsNotifications_other: 'This card has {{count}} notifications',
      detectAutomatically: 'Detect automatically',
      disabled: 'Disabled',
      docs: 'Documentation',
      done: 'Done',
      dropFileToUpload: 'Drop files to upload',
      dueDate_title: 'Due Date',
      dueDateSummary: 'Closest due date for unfinished task:',
      duplicateTask: 'Duplicate Task',
      editAllowedRegisterDomains: 'Edit Allowed Registration Domains',
      editAttachment_title: 'Edit Attachment',
      editAttachment: 'Edit Attachment',
      editAttachmentName: 'Edit Attachment Name',
      editAvatar_title: 'Edit Avatar',
      editBoard_title: 'Edit Board',
      editCard: 'Edit Card',
      editComment: 'Edit Comment',
      editDescription: 'Edit Description',
      editDueDate_title: 'Edit Due Date',
      editDueDate: 'Edit Due Date',
      edited: 'Edited',
      editEmail_title: 'Edit Email',
      editInformation_title: 'Edit Information',
      editLabel_title: 'Edit Label',
      editLabel: 'Edit Label',
      editLabels: 'Edit Labels',
      editList: 'Edit List',
      editListView: 'Edit List View',
      editMembers: 'Edit Members',
      editor: 'Editor',
      editPassword_title: 'Edit Password',
      editPermissions_title: 'Edit Permissions',
      editProject: 'Edit Project',
      editTask: 'Edit Task',
      editTimer_title: 'Edit Timer',
      editTimer: 'Edit Timer',
      editUser: 'Edit User',
      editUsername_title: 'Edit Username',
      email: 'Email',
      emailAlreadyInUse: 'Email already in use',
      empty: 'Empty',
      enabled: 'Enabled',
      enableLocalRegistration: 'Local User Registration',
      enableProjectCreationAll: 'Project Creation For All Users',
      enableRegistration: 'User Registration',
      enableSsoRegistration: 'SSO User Registration',
      enterAttachmentName: 'Enter attachment name...',
      enterBoardName: 'Enter board name...',
      enterCardName: 'Enter card name...',
      enterCardNameWithHint: 'Enter card name... [Ctrl+Enter] - open',
      enterComment: 'Enter comment...',
      enterDescription: 'Enter description...',
      enterDueDate: 'Enter due date...',
      enterFileName: 'Enter file name...',
      enterGithubRepository: 'Enter GitHub repository... <Owner/Repo>',
      enterLabelName: 'Enter label name...',
      enterListName: 'Enter list name...',
      enterProjectName: 'Enter project name...',
      enterTaskDescription: 'Enter task description...',
      excludingNonMembershipProjects: "(excluding projects you're not a part of)",
      expandList: 'Expand List',
      exportBoard_title: 'Export Board',
      exportBoardExplanation: 'Your download will start automatically, when the export is ready.',
      exportSkipActions: 'Skip actions (history)',
      exportSkipAttachments: 'Skip attachments',
      exportSkipMetadata: 'Skip metadata',
      exportSkipProjectBackgrounds: 'Skip project backgrounds',
      exportSkipUserAvatars: 'Skip user avatars',
      facebook: 'Facebook',
      feedbackExtra: 'It means a lot for us',
      feedbackMain: "We'd love to hear your feedback!",
      fetching: 'Fetching...',
      filterBoards: 'Filter boards...',
      filterByAggregated: 'Filter by Project/Board/User/Card/Text/Activity Type...',
      filterByBoard: 'Filter by Board...',
      filterByCard: 'Filter by Card...',
      filterByDueDate_title: 'Filter by Due Date',
      filterByLabels_title: 'Filter By Labels',
      filterByMembers_title: 'Filter By Members',
      filterByNotifications_title: 'Filter by Notifications',
      filterByProject: 'Filter by Project...',
      filterByText: 'Filter by Text/Activity Type...',
      filterByUser: 'Filter by User...',
      filterCards: 'Filter cards...',
      filterIdAggregated: 'Aggregated',
      filterIdBoard: 'Board',
      filterIdCard: 'Card',
      filterIdProject: 'Project',
      filterIdText: 'Text',
      filterIdUser: 'User',
      filterProjects: 'Filter projects...',
      firstPage: 'First Page',
      from4gaBoards: 'From 4ga Boards',
      fromTrello: 'From Trello',
      general: 'General',
      github: 'GitHub',
      hasDescription: 'Has Description',
      hideBoards: 'Hide boards',
      hideCardModalActivity: 'Hide Card Modal Activity',
      hideClosestDueDate: 'Hide Closest Due Date',
      hideSidebar: 'Hide Sidebar',
      hideTasks: 'Hide Tasks',
      hours: 'Hours',
      ideas: 'Open',
      importBoard_title: 'Import Board',
      importGettingStartedProject: 'Import Getting Started Project',
      importNonExistingUsers: 'Create accounts for non-existing users',
      importProjectManagers: 'Add project managers',
      inProgress: 'In Progress',
      instanceSettings: 'Instance Settings',
      insufficientPermissions: 'Insufficient permissions',
      invalidCurrentPassword: 'Invalid current password',
      justSelectedDay: 'Show Cards Just For Selected Day',
      kanban: 'Kanban',
      labels: 'Labels',
      language: 'Language',
      lastLogin: 'Last login',
      lastPage: 'Last Page',
      latestVersion: 'Latest version:',
      leaveBoard_title: 'Leave Board',
      leaveProject_title: 'Leave Project',
      linkCard: 'Copy Link',
      linkedin: 'LinkedIn',
      list: 'List',
      listActions_title: 'List Actions',
      listView: 'List',
      listViewStyle: 'List View Style',
      managers: 'Managers',
      markAllAsRead: 'Mark All as Read',
      markAllAsUnread: 'Mark All as Unread',
      markAsCompleted: 'Mark task as completed',
      markAsUncompleted: 'Mark task as uncompleted',
      matchCase: 'Match Case [Alt+C]',
      members: 'Members',
      minutes: 'Minutes',
      modifySettings: 'Modify Settings',
      monospace: 'Monospace',
      moveCard_title: 'Move Card',
      moveCardToList: 'Move Card To List',
      name: 'Name',
      needInvite: 'No Projects Available - Ask for an invitation.',
      newEmail: 'New e-mail',
      newPassword: 'New password',
      newUsername: 'New username',
      nextPage: 'Next Page',
      noBoards: 'No boards',
      noConnection: "No connection - Please don't reload the tab!",
      noLists: 'No lists',
      noLongerBoardMember: 'This user is no longer a member of this board!',
      noLongerProjectMember: 'This user is no longer a member of this project!',
      noProjects: 'No projects',
      notConnectedToGithub: 'Not connected to GitHub',
      notificationActions: 'Notification Actions',
      notifications: 'Notifications',
      notificationsWithCount: 'Notifications <0>({{unread}}/{{total}})</0>',
      noUnreadNotifications: 'No unread notifications',
      ofBoards_one: '{{filteredCount}} of {{count}} board',
      ofBoards_other: '{{filteredCount}} of {{count}} boards',
      ofCards_one: '{{filteredCount}} of {{count}} card',
      ofCards_other: '{{filteredCount}} of {{count}} cards',
      ofNotifications_one: '{{filteredCount}} of {{count}} notification',
      ofNotifications_other: '{{filteredCount}} of {{count}} notifications',
      ofProjects_one: '{{filteredCount}} of {{count}} project',
      ofProjects_other: '{{filteredCount}} of {{count}} projects',
      openDropdown: 'Open dropdown',
      openNotificationCenter: 'Open Notification Center',
      optional_inline: 'optional',
      or: 'or',
      organization: 'Organization',
      perPage: 'per page',
      phone: 'Phone',
      preferences: 'Preferences',
      preferredDetailsFont: 'Preferred Details Font',
      previousPage: 'Previous Page',
      profile: 'Profile',
      profileAndSettings: 'Profile and Settings',
      project_title: 'Project',
      project: 'project',
      projectNotFound_title: 'Project Not Found',
      projects_one: '{{count}} project',
      projects_other: '{{count}} projects',
      projects_title_one: '{{count}} Project',
      projects_title_other: '{{count}} Projects',
      projects_title: 'Projects',
      projects: 'projects',
      projectSettings: 'Project Settings',
      removeManager_title: 'Remove Manager',
      removeMember_title: 'Remove Member',
      renameBoard: 'Rename Board',
      renameProject: 'Rename Project',
      reorderBoards: 'Reorder boards within the project',
      requiresAdminRights: '(requires admin rights)',
      resetColumnFilters: 'Reset Column Filters',
      resetColumnSorting: 'Reset Column Sorting',
      resetColumnVisibility: 'Reset Column Visibility',
      resetColumnWidths: 'Adjust Columns to Fit Content',
      resetColumnWidthsFitScreen: 'Adjust Columns to Fit Screen',
      resizeColumn: 'Resize column',
      searchLabels: 'Search labels or create one...',
      searchMembers: 'Search members...',
      searchUsers: 'Search users...',
      seconds: 'Seconds',
      selectAll: 'Select All',
      selectBoard: 'Select board',
      selectColumns: 'Select Columns',
      selectDefault: 'Select Default',
      selectList: 'Select list',
      selectNone: 'Select None',
      selectPermissions_title: 'Select Permissions',
      selectProject: 'Select project',
      setPassword_title: 'Set Password',
      settings: 'Settings',
      settingsAbout: 'Settings: About',
      settingsAccount: 'Settings: Account',
      settingsAuthentication: 'Settings: Authentication',
      settingsInstance: 'Settings: Instance',
      settingsPreferences: 'Settings: Preferences',
      settingsProfile: 'Settings: Profile',
      settingsProject: 'Settings: Project',
      settingsUsers: 'Settings: Users',
      showBoards: 'Show boards',
      showing: 'Showing',
      showSidebar: 'Show Sidebar',
      showTasks: 'Show Tasks',
      sidebarCompact: 'Compact Sidebar',
      simple: 'Simple',
      ssoGithubEmail: 'GitHub Email',
      ssoGithubUsername: 'GitHub Username',
      ssoGoogleEmail: 'Google Email',
      ssoMicrosoftEmail: 'Microsoft Email',
      ssoOidcEmail: 'OIDC Email',
      startTimer: 'Start Timer',
      stopTimer: 'Stop Timer',
      subscribed: 'Subscribed',
      subscribeToInstance: 'Subscribe to instance notifications',
      subscribeToNewBoards: 'Subscribe to new boards',
      subscribeToNewProjects: 'Subscribe to new projects',
      subscribeToOwnCards: 'Subscribe to my own cards',
      subscribeToUsers: 'Subscribe to users notifications',
      supportDevelopment: 'Support 4ga Boards Development',
      switchToBoardView: 'Switch to Board View',
      switchToListView: 'Switch to List View',
      syncSsoAdminOnAuth: 'Sync SSO Admin on Authentication',
      syncSsoDataOnAuth: 'Sync SSO Data on Authentication',
      taskActions_title: 'Task Actions',
      tasks: 'Tasks',
      template: 'Template',
      theme: 'Theme',
      themeDefault: 'Default',
      themeGithubDark: 'GitHub Dark',
      themeShape: 'Theme Shape',
      themeShapeDefault: 'Default',
      themeShapeRounded: 'Rounded',
      thereIsNoPreviewAvailableForThisAttachment: 'There is no preview available for this attachment',
      time: 'Time',
      timer: 'Timer',
      todo: 'Todo',
      toggleAdmin: 'Toggle Admin',
      toggleAttachments: 'Toggle Attachments',
      toggleColumnVisibility: 'Toggle column visibility',
      toggleComments: 'Toggle Comments',
      toggleCompactSidebar: 'Toggle compact sidebar',
      toggleDescription: 'Toggle Description',
      toggleFilter: 'Toggle filter: boards/projects [Tab]',
      toggleHideCardModalActivity: 'Toggle hide card modal activity',
      toggleHideClosestDueDate: 'Toggle hide closest due date',
      toggleLocalUserRegistration: 'Toggle Local User Registration',
      toggleNotificationFilter: 'Toggle notification filter: aggregated/project/board/user/card/text [Tab]',
      toggleProjectCreationAll: 'Toggle Project Creation for all Users',
      toggleSettings: 'Toggle Settings',
      toggleSsoUserRegistration: 'Toggle SSO User Registration',
      toggleSubscribeToInstance: 'Toggle subscribe to instance notifications',
      toggleSubscribeToNewBoards: 'Toggle subscribe to new boards',
      toggleSubscribeToNewProjects: 'Toggle subscribe to new projects',
      toggleSubscribeToOwnCards: 'Toggle subscribe to my own cards',
      toggleSubscribeToUsers: 'Toggle subscribe to users notifications',
      toggleSyncSsoAdminOnAuth: 'Toggle Sync SSO Admin on Authentication',
      toggleSyncSsoDataOnAuth: 'Toggle Sync SSO Data on Authentication',
      toggleTasks: 'Toggle Tasks',
      toggleUserRegistration: 'Toggle User Registration',
      toTest: 'To Test',
      unableToFetch: 'Unable to fetch',
      unsavedChanges: 'Local changes',
      updated: 'Updated',
      updatedAt: 'Updated At',
      updatedBy: 'Updated By',
      userAccountNotifications: 'User Account Notifications',
      userActions_title: 'User Actions',
      userAvatar: 'User Avatar',
      username: 'Username',
      usernameAlreadyInUse: 'Username already in use',
      users: 'Users',
      usersSettingsStyle: 'Users Settings Style',
      version: 'Version:',
      viewer: 'Viewer',
      weakPassword: 'Please use stronger password',
      website: 'Website',
      writeComment: 'Write a comment...',
      writeCommentHint: '[Ctrl+Enter] - submit',
      x: 'X',
      you: '(You)',
      youtube: 'YouTube',
    },

    activity: {
      instanceUpdateSettings: 'Updated instance settings: <0>{{settings}}</0>',
      userCreate: 'Created user <0>{{userName}}</0> (<1>{{userEmail}}</1>) - admin: <2>{{isAdmin}}</2>',
      userRegisterLocal: 'Registered local user <0>{{userName}}</0> (<1>{{userEmail}}</1>) - admin: <2>{{isAdmin}}</2>',
      userRegisterOidc: 'Registered OIDC user <0>{{userName}}</0> (<1>{{userEmail}}</1>) - admin: <2>{{isAdmin}}</2>',
      userUpdateName: 'Updated user <0>{{prevUserName}}</0> to <1>{{userName}}</1>',
      userUpdateEmail: 'Updated user <0>{{userName}}</0> email from <1>{{prevUserEmail}}</1> to <2>{{userEmail}}</2>',
      userUpdateUsername: 'Updated username <0>{{prevUsername}}</0> to <1>{{username}}</1>',
      userUpdateIsAdmin: 'Updated user <0>{{userName}}</0> admin from <1>{{prevIsAdmin}}</1> to <2>{{isAdmin}}</2>',
      userUpdateAvatar: 'Updated avatar for user <0>{{userName}}</0>',
      userUpdateSsoGoogleEmail: 'Updated user <0>{{userName}}</0> Google SSO email from <1>{{prevSsoGoogleEmail}}</1> to <2>{{ssoGoogleEmail}}</2>',
      userUpdateSsoGithubEmail: 'Updated user <0>{{userName}}</0> GitHub SSO email from <1>{{prevSsoGithubEmail}}</1> to <2>{{ssoGithubEmail}}</2>',
      userUpdateSsoMicrosoftEmail: 'Updated user <0>{{userName}}</0> Microsoft SSO email from <1>{{prevSsoMicrosoftEmail}}</1> to <2>{{ssoMicrosoftEmail}}</2>',
      userUpdateSsoOidcEmail: 'Updated user <0>{{userName}}</0> OIDC SSO email from <1>{{prevSsoOidcEmail}}</1> to <2>{{ssoOidcEmail}}</2>',
      userUpdatePasswordChanged: 'Changed password for user <0>{{userName}}</0>',
      userDelete: 'Deleted user <0>{{userName}}</0> (<1>{{userEmail}}</1>)',
      projectCreate: 'Created project <0>{{project}}</0>',
      projectCreateShort: 'Created this project',
      projectUpdateName: 'Updated project <0>{{prevProject}}</0> to <1>{{project}}</1>',
      projectUpdateNameShort: 'Updated project <0>{{prevProject}}</0> to <1>{{project}}</1>',
      projectBackgroundAdd: 'Added background to project <0>{{project}}</0>',
      projectBackgroundAddShort: 'Added background to this project',
      projectBackgroundUpdate: 'Updated project <0>{{project}}</0> background',
      projectBackgroundUpdateShort: 'Updated this project background',
      projectBackgroundRemove: 'Removed background from project <0>{{project}}</0>',
      projectBackgroundRemoveShort: 'Removed background from this project',
      projectDelete: 'Deleted project <0>{{project}}</0>',
      projectDeleteShort: 'Deleted this project',
      projectManagerAdd: 'Added <0>{{user}}</0> as manager to project <1>{{project}}</1>',
      projectManagerAddShort: 'Added <0>{{user}}</0> as manager to this project',
      projectManagerRemove: 'Removed <0>{{user}}</0> from managers of project <1>{{project}}</1>',
      projectManagerRemoveShort: 'Removed <0>{{user}}</0> from managers of this project',
      boardCreate: 'Created board <0>{{board}}</0> (imported: <1>{{isImportedBoard}}</1>) in <2>{{project}}</2>',
      boardCreateShort: 'Created this board (imported: <1>{{isImportedBoard}}</1>) in <2>{{project}}</2>',
      boardUpdateName: 'Updated board <0>{{prevBoard}}</0> to <1>{{board}}</1>',
      boardUpdateNameShort: 'Updated board <0>{{prevBoard}}</0> to <1>{{board}}</1>',
      boardUpdatePosition: 'Updated board <0>{{board}}</0> position in <1>{{project}}</1>',
      boardUpdatePositionShort: 'Updated this board position in <1>{{project}}</1>',
      boardAddedGithubRepo: 'Added GitHub repository <2>{{githubRepo}}</2> to board <1>{{board}}</1>',
      boardAddedGithubRepoShort: 'Added GitHub repository <2>{{githubRepo}}</2> to this board',
      boardUpdateGithubRepo: 'Updated board <0>{{board}}</0> GitHub repository from <1>{{prevGithubRepo}}</1> to <2>{{githubRepo}}</2>',
      boardUpdateGithubRepoShort: 'Updated this board GitHub repository from <1>{{prevGithubRepo}}</1> to <2>{{githubRepo}}</2>',
      boardRemovedGithubRepo: 'Removed GitHub repository <2>{{githubRepo}}</2> from board <0>{{board}}</0>',
      boardRemovedGithubRepoShort: 'Removed GitHub repository <2>{{githubRepo}}</2> from this board',
      boardDelete: 'Deleted board <0>{{board}}</0> from <1>{{project}}</1>',
      boardDeleteShort: 'Deleted this board from <1>{{project}}</1>',
      boardUserAdd: 'Added <0>{{user}}</0> to board <1>{{board}}</1> as <2>{{role}}</2> (can comment: <3>{{canComment}}</3>)',
      boardUserAddShort: 'Added <0>{{user}}</0> to this board as <2>{{role}}</2> (can comment: <3>{{canComment}}</3>)',
      boardUserUpdateRole: 'Updated <0>{{user}}</0> role from <1>{{prevRole}}</1> (can comment: <2>{{prevCanComment}}</2>) to <3>{{role}}</3> (can comment: <4>{{canComment}}</4>) in board <5>{{board}}</5>',
      boardUserUpdateRoleShort: 'Updated <0>{{user}}</0> role from <1>{{prevRole}}</1> (can comment: <2>{{prevCanComment}}</2>) to <3>{{role}}</3> (can comment: <4>{{canComment}}</4>) in this board',
      boardUserUpdateCanComment: 'Updated <0>{{user}}</0> permission to comment to <1>{{canComment}}</1> in board <2>{{board}}</2>',
      boardUserUpdateCanCommentShort: 'Updated <0>{{user}}</0> permission to comment to <1>{{canComment}}</1> in this board',
      boardUserRemove: 'Removed <0>{{user}}</0> from board <1>{{board}}</1>',
      boardUserRemoveShort: 'Removed <0>{{user}}</0> from this board',
      labelCreate: 'Created label <0>{{label}}</0> in <1>{{board}}</1>',
      labelCreateShort: 'Created this label in <1>{{board}}</1>',
      labelUpdateName: 'Updated label <1>{{prevLabel}}</1> to <0>{{label}}</0>',
      labelUpdateNameShort: 'Updated label <1>{{prevLabel}}</1> to <0>{{label}}</0>',
      labelUpdateColor: 'Updated label <0>{{label}}</0> color to <1>{{color}}</1>',
      labelUpdateColorShort: 'Updated this label color to <1>{{color}}</1>',
      labelDelete: 'Deleted label <0>{{label}}</0> from <1>{{board}}</1>',
      labelDeleteShort: 'Deleted label from <1>{{board}}</1>',
      listCreate: 'Created list <0>{{list}}</0> in <1>{{board}}</1>',
      listCreateShort: 'Created this list in <1>{{board}}</1>',
      listUpdateName: 'Updated list <1>{{prevList}}</1> name to <0>{{list}}</0>',
      listUpdateNameShort: 'Updated list <1>{{prevList}}</1> name to <0>{{list}}</0>',
      listCollapse: 'Collapsed list <0>{{list}}</0>',
      listCollapseShort: 'Collapsed this list',
      listExpand: 'Expanded list <0>{{list}}</0>',
      listExpandShort: 'Expanded this list',
      listUpdatePosition: 'Updated list <0>{{list}}</0> position in <1>{{board}}</1>',
      listUpdatePositionShort: 'Updated this list position in <1>{{board}}</1>',
      listDelete: 'Deleted list <0>{{list}}</0> from <1>{{board}}</1>',
      listDeleteShort: 'Deleted this list from <1>{{board}}</1>',
      cardCreate: 'Created <0>{{card}}</0> in <1>{{list}}</1>',
      cardCreateShort: 'Created this card in <1>{{list}}</1>',
      cardDuplicate: 'Duplicated <0>{{card}}</0> in <1>{{list}}</1>',
      cardDuplicateShort: 'Duplicated this card in <1>{{list}}</1>',
      cardMove: 'Moved <0>{{card}}</0> from <1>{{fromList}}</1> to <2>{{toList}}</2>',
      cardMoveShort: 'Moved this card from <1>{{fromList}}</1> to <2>{{toList}}</2>',
      cardTransferProject: 'Transferred <0>{{card}}</0> from <1>{{fromList}}</1> in <2>{{fromBoard}}</2> (<5>{{fromProject}}</5>) to <3>{{toList}}</3> in <4>{{toBoard}}</4> (<6>{{toProject}}</6>)',
      cardTransferProjectShort: 'Transferred this card from <1>{{fromList}}</1> in <2>{{fromBoard}}</2> (<5>{{fromProject}}</5>) to <3>{{toList}}</3> in <4>{{toBoard}}</4> (<6>{{toProject}}</6>)',
      cardTransferBoard: 'Transferred <0>{{card}}</0> within project from <1>{{fromList}}</1> in <2>{{fromBoard}}</2> (<5>{{fromProject}}</5>) to <3>{{toList}}</3> in <4>{{toBoard}}</4> (<6>{{toProject}}</6>)',
      cardTransferBoardShort: 'Transferred this card within project from <1>{{fromList}}</1> in <2>{{fromBoard}}</2> (<5>{{fromProject}}</5>) to <3>{{toList}}</3> in <4>{{toBoard}}</4> (<6>{{toProject}}</6>)',
      cardDelete: 'Deleted <0>{{card}}</0> from <1>{{list}}</1>',
      cardDeleteShort: 'Deleted this card from <1>{{list}}</1>',
      cardUpdateName: 'Updated <1>{{prevCard}}</1> to <0>{{card}}</0>',
      cardUpdateNameShort: 'Updated <1>{{prevCard}}</1> to <0>{{card}}</0>',
      cardUpdateDescription: 'Updated description from <2>{{prevDescription}}</2> to <1>{{description}}</1> of <0>{{card}}</0>',
      cardUpdateDescriptionShort: 'Updated description from <2>{{prevDescription}}</2> to <1>{{description}}</1>',
      cardUpdateDescriptionAdd: 'Added description <1>{{description}}</1> to <0>{{card}}</0>',
      cardUpdateDescriptionAddShort: 'Added description <1>{{description}}</1> to this card',
      cardUpdateDescriptionRemove: 'Removed description <2>{{prevDescription}}</2> from <0>{{card}}</0>',
      cardUpdateDescriptionRemoveShort: 'Removed description <2>{{prevDescription}}</2> from this card',
      cardUpdateDueDate: 'Updated due date from <2>{{prevDueDate}}</2> to <1>{{dueDate}}</1> of <0>{{card}}</0>',
      cardUpdateDueDateShort: 'Updated due date from <2>{{prevDueDate}}</2> to <1>{{dueDate}}</1>',
      cardUpdateDueDateAdd: 'Added due date <1>{{dueDate}}</1> to <0>{{card}}</0>',
      cardUpdateDueDateAddShort: 'Added due date <1>{{dueDate}}</1> to this card',
      cardUpdateDueDateRemove: 'Removed due date from <0>{{card}}</0>',
      cardUpdateDueDateRemoveShort: 'Removed due date from this card',
      cardUpdateTimerStart: 'Resumed timer from <1>{{prevTimer}}</1> on <0>{{card}}</0>',
      cardUpdateTimerStartShort: 'Resumed timer from <1>{{prevTimer}}</1>',
      cardUpdateTimerStop: 'Stopped timer on <1>{{timer}}</1> from <2>{{prevTimer}}</2> on <0>{{card}}</0>',
      cardUpdateTimerStopShort: 'Stopped timer on <1>{{timer}}</1> from <2>{{prevTimer}}</2>',
      cardUpdateTimerEdit: 'Edited timer from <2>{{prevTimer}}</2> to <1>{{timer}}</1> on <0>{{card}}</0>',
      cardUpdateTimerEditShort: 'Edited timer from <2>{{prevTimer}}</2> to <1>{{timer}}</1> on this card',
      cardUpdateTimerAdd: 'Started timer <1>{{timer}}</1> on <0>{{card}}</0>',
      cardUpdateTimerAddShort: 'Started timer <1>{{timer}}</1> on this card',
      cardUpdateTimerRemove: 'Removed timer <2>{{prevTimer}}</2> from <0>{{card}}</0>',
      cardUpdateTimerRemoveShort: 'Removed timer <2>{{prevTimer}}</2> from this card',
      cardUpdateCoverAttachment: 'Updated cover attachment from <2>{{prevCoverAttachment}}</2> to <1>{{coverAttachment}}</1> in <0>{{card}}</0>',
      cardUpdateCoverAttachmentShort: 'Updated cover attachment from <2>{{prevCoverAttachment}}</2> to <1>{{coverAttachment}}</1>',
      cardUpdateCoverAttachmentAdd: 'Added cover attachment <1>{{coverAttachment}}</1> to <0>{{card}}</0>',
      cardUpdateCoverAttachmentAddShort: 'Added cover attachment <1>{{coverAttachment}}</1> to this card',
      cardUpdateCoverAttachmentRemove: 'Removed cover attachment <2>{{prevCoverAttachment}}</2> from <0>{{card}}</0>',
      cardUpdateCoverAttachmentRemoveShort: 'Removed cover attachment <2>{{prevCoverAttachment}}</2> from this card',
      cardUpdatePosition: 'Updated <0>{{card}}</0> position in <1>{{list}}</1>',
      cardUpdatePositionShort: 'Updated card position in <1>{{list}}</1>',
      cardCommentCreate: 'Added comment <1>{{comment}}</1> to <0>{{card}}</0>',
      cardCommentCreateShort: 'Added comment <1>{{comment}}</1>',
      cardCommentUpdate: 'Updated comment <1>{{prevComment}}</1> to <2>{{comment}}</2> (author: <3>{{user}}</3>) in <0>{{card}}</0>',
      cardCommentUpdateShort: 'Updated comment <1>{{prevComment}}</1> to <2>{{comment}}</2> (author: <3>{{user}}</3>)',
      cardCommentUpdateOwn: 'Updated own comment <1>{{prevComment}}</1> to <2>{{comment}}</2> in <0>{{card}}</0>',
      cardCommentUpdateOwnShort: 'Updated own comment <1>{{prevComment}}</1> to <2>{{comment}}</2>',
      cardCommentDelete: 'Deleted comment <1>{{comment}}</1> by <2>{{user}}</2> from <0>{{card}}</0>',
      cardCommentDeleteShort: 'Deleted comment <1>{{comment}}</1> by <2>{{user}}</2>',
      cardUserAdd: 'Added user <1>{{user}}</1> to <0>{{card}}</0>',
      cardUserAddShort: 'Added user <1>{{user}}</1> to this card',
      cardUserRemove: 'Removed user <1>{{user}}</1> from <0>{{card}}</0>',
      cardUserRemoveShort: 'Removed user <1>{{user}}</1> from this card',
      cardTaskCreate: 'Created task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskCreateShort: 'Created task <1>{{task}}</1>',
      cardTaskUpdateName: 'Updated task <1>{{prevTask}}</1> to <2>{{task}}</2> in <0>{{card}}</0>',
      cardTaskUpdateNameShort: 'Updated task <1>{{prevTask}}</1> to <2>{{task}}</2>',
      cardTaskUpdateIsCompleted: 'Marked task <1>{{task}}</1> as <2>{{isCompleted}}</2> in <0>{{card}}</0>',
      cardTaskUpdateIsCompletedShort: 'Marked task <1>{{task}}</1> as <2>{{isCompleted}}</2>',
      cardTaskCompleted: 'completed',
      cardTaskUncompleted: 'uncompleted',
      cardTaskUpdateDueDate: 'Updated due date from <3>{{prevDueDate}}</3> to <2>{{dueDate}}</2> in task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskUpdateDueDateShort: 'Updated due date from <3>{{prevDueDate}}</3> to <2>{{dueDate}}</2> in task <1>{{task}}</1> ',
      cardTaskUpdateDueDateAdd: 'Added due date <2>{{dueDate}}</2> to task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskUpdateDueDateAddShort: 'Added due date <2>{{dueDate}}</2> to task <1>{{task}}</1>',
      cardTaskUpdateDueDateRemove: 'Removed due date from task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskUpdateDueDateRemoveShort: 'Removed due date from task <1>{{task}}</1>',
      cardTaskDuplicate: 'Duplicated task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskDuplicateShort: 'Duplicated task <1>{{task}}</1>',
      cardTaskMove: 'Updated task <1>{{task}}</1> position in <0>{{card}}</0>',
      cardTaskMoveShort: 'Updated task <1>{{task}}</1> position',
      cardTaskDelete: 'Deleted task <1>{{task}}</1> from <0>{{card}}</0>',
      cardTaskDeleteShort: 'Deleted task <1>{{task}}</1>',
      cardTaskUserAdd: 'Added user <2>{{user}}</2> to task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskUserAddShort: 'Added user <2>{{user}}</2> to task <1>{{task}}</1>',
      cardTaskUserRemove: 'Removed user <2>{{user}}</2> from task <1>{{task}}</1> in <0>{{card}}</0>',
      cardTaskUserRemoveShort: 'Removed user <2>{{user}}</2> from task <1>{{task}}</1>',
      cardAttachmentCreate: 'Added attachment <1>{{attachment}}</1> to <0>{{card}}</0>',
      cardAttachmentCreateShort: 'Added attachment <1>{{attachment}}</1>',
      cardAttachmentUpdate: 'Renamed attachment <1>{{prevAttachment}}</1> to <2>{{attachment}}</2> in <0>{{card}}</0>',
      cardAttachmentUpdateShort: 'Renamed attachment <1>{{prevAttachment}}</1> to <2>{{attachment}}</2>',
      cardAttachmentDelete: 'Deleted attachment <1>{{attachment}}</1> from <0>{{card}}</0>',
      cardAttachmentDeleteShort: 'Deleted attachment <1>{{attachment}}</1>',
      cardLabelAdd: 'Added label <1>{{label}}</1> to <0>{{card}}</0>',
      cardLabelAddShort: 'Added label <1>{{label}}</1>',
      cardLabelRemove: 'Removed label <1>{{label}}</1> from <0>{{card}}</0>',
      cardLabelRemoveShort: 'Removed label <1>{{label}}</1>',
      deletedCard: 'Deleted or unavailable card:\n{{card}}',
      deletedBoard: 'Deleted or unavailable board:\n{{board}}',
      deletedProject: 'Deleted or unavailable project:\n{{project}}',
      noBoardAvailable: 'No board available',
      noProjectAvailable: 'No project available',
      markAsRead: 'Mark as read',
      markAsUnread: 'Mark as unread',
      delete: 'Delete',
      yes: 'yes',
      no: 'no',
      none: 'none',
      instanceShort: 'Instance',
      userShort: 'User',
      projectShort: 'Project',
      boardShort: 'Board',
      listShort: 'List',
      cardShort: 'Card',
      taskShort: 'Task',
      commentShort: 'Comment',
      attachmentShort: 'Atch.',
    },

    errors: {
      noOidcProfileFound: 'No OIDC profile found',
      domainNotAllowed: 'You cannot register with an email from this domain',
    },

    action: {
      addCard_title: 'Add Card',
      addCard: 'Add card',
      addComment: 'Add comment',
      addDescription: 'Add description',
      addList: 'Add list',
      addMember: 'Add member',
      addTask: 'Add task',
      addUser: 'Add user',
      backToProject: 'Back to project',
      cancel: 'Cancel',
      createFile: 'Create file',
      createLabel: 'Create label',
      createNewLabel: 'Create new label',
      delete: 'Delete',
      deleteAttachment: 'Delete attachment',
      deleteAvatar: 'Delete avatar',
      deleteBoard: 'Delete board',
      deleteCard_title: 'Delete Card',
      deleteCard: 'Delete card',
      deleteComment: 'Delete comment',
      deleteImage: 'Delete image',
      deleteLabel: 'Delete label',
      deleteList_title: 'Delete List',
      deleteList: 'Delete list',
      deleteProject_title: 'Delete Project',
      deleteProject: 'Delete project',
      deleteTask_title: 'Delete Task',
      deleteTask: 'Delete task',
      deleteUser: 'Delete user',
      duplicateCard: 'Duplicate Card',
      edit: 'Edit',
      editDescription_title: 'Edit Description',
      editDueDate_title: 'Edit Due Date',
      editEmail_title: 'Edit Email',
      editInformation_title: 'Edit Information',
      editName_title: 'Edit Name',
      editPassword_title: 'Edit Password',
      editPermissions: 'Edit permissions',
      editTimer_title: 'Edit Timer',
      editUsername_title: 'Edit Username',
      hideDetails: 'Hide activity',
      import: 'Import',
      leaveBoard: 'Leave board',
      leaveProject: 'Leave project',
      logOut_title: 'Log Out',
      makeCover_title: 'Make Cover',
      move: 'Move',
      moveCard_title: 'Move Card',
      remove: 'Remove',
      removeBackground: 'Remove background',
      removeCover_title: 'Remove Cover',
      removeFromBoard: 'Remove from board',
      removeFromProject: 'Remove from project',
      removeManager: 'Remove manager',
      removeMember: 'Remove member',
      save: 'Save',
      showAllAttachments: 'Show all attachments ({{hidden}} hidden)',
      showDetails: 'Show activity',
      showFewerAttachments: 'Show fewer attachments',
      start: 'Start',
      stop: 'Stop',
      subscribe: 'Subscribe',
      unsubscribe: 'Unsubscribe',
      uploadNewAvatar: 'Upload new avatar',
      uploadNewImage: 'Upload new image',
    },
  },
};
